import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "details-step__wrap" }
const _hoisted_2 = { class: "details-step__header" }
const _hoisted_3 = { class: "details-step__details h3" }
const _hoisted_4 = { class: "details-step" }
const _hoisted_5 = { class: "form-screen__body" }
const _hoisted_6 = { class: "h2 color-text-primary details-step__title" }
const _hoisted_7 = { class: "details-step__period_drop-down" }
const _hoisted_8 = {
  key: 0,
  class: "details-step__select-list"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "h1 color-secondary details-step__select_title" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "color-error hint bold"
}
const _hoisted_13 = { class: "details-step__format" }
const _hoisted_14 = { class: "h4 color-text-primary" }
const _hoisted_15 = { class: "details-step__format_radio" }
const _hoisted_16 = { class: "radio-item" }
const _hoisted_17 = { class: "radio-item" }
const _hoisted_18 = { class: "form-screen__footer" }


import BaseButton from "@/components/base/BaseButton.vue";
import AsideModal from "@/components/aside/AsideModal.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useSettingsDetails } from "@/composables/settings/useSettingsDetails";


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  emits: ["submit", "back"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const {
  changePeriod,
  clearData,
  email,
  format,
  handleEmailFocus,
  handleSubmit,
  isEmailError,
  isPeriodListShow,
  isValid,
  period,
  periods,
  validateEmail,
  isSelectPoint,
} = useSettingsDetails(emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "details-step__back",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(clearData) && _unref(clearData)(...args)))
      }, [
        _createVNode(BaseFigureForIcon, {
          size: "medium",
          color: "white",
          icon: "arrow",
          position: "left",
          "is-button": ""
        })
      ]),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("settings.detailsView.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("settings.detailsView.subtitle")), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "details-step__select caption-select color-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isPeriodListShow.value = true))
          }, [
            _createTextVNode(_toDisplayString(_unref(period).title) + " ", 1),
            _createVNode(BaseIcon, {
              name: "more",
              position: _unref(isPeriodListShow) ? 'top' : 'bottom',
              class: "details-step__select-icon"
            }, null, 8, ["position"])
          ]),
          (_unref(isPeriodListShow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periods), (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["details-step__select-item color-grey-light caption-select--bold", { 'active-select': section.title === _unref(period).title }]),
                    key: section.key,
                    onClick: ($event: any) => (_unref(changePeriod)(section))
                  }, _toDisplayString(section.title), 11, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(AsideModal, {
            "is-show": _unref(isPeriodListShow),
            "is-white": true,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (isPeriodListShow.value = false)),
            class: "details-step__select-list--mobile"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("settings.detailsView.selectPeriod")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periods), (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["details-step__period_mobile", {
                'active-select_background': section.title === _unref(period).title,
              }]),
                  key: section.key,
                  onClick: ($event: any) => (_unref(changePeriod)(section))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["color-text-primary caption-select--bold", {
                  'active-select_text': section.title === _unref(period).title,
                }])
                  }, _toDisplayString(section.title), 3),
                  _createVNode(BaseFigureForIcon, {
                    icon: _unref(isSelectPoint)(section.title) ? 'check-sharp' : 'more',
                    size: "small",
                    color: 
                  _unref(isSelectPoint)(section.title)
                    ? 'white-opacity-15'
                    : 'secondary'
                
                  }, null, 8, ["icon", "color"])
                ], 10, _hoisted_11))
              }), 128))
            ]),
            _: 1
          }, 8, ["is-show"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BaseInput, {
            modelValue: _unref(email),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
            type: "email",
            "has-error": _unref(isEmailError),
            onFocus: _unref(handleEmailFocus),
            placeholder: _ctx.$t('settings.detailsView.emailPlaceholder'),
            onValidation: _unref(validateEmail)
          }, null, 8, ["modelValue", "has-error", "onFocus", "placeholder", "onValidation"]),
          (_unref(isEmailError) && _unref(email))
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("settings.detailsView.emailError")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("settings.detailsView.fileFormat")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "format_pdf",
                value: "PDF",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(format) ? (format).value = $event : null))
              }, null, 512), [
                [_vModelRadio, _unref(format)]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "format_pdf" }, "PDF", -1))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "format_xlsx",
                value: "xlsx",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(format) ? (format).value = $event : null))
              }, null, 512), [
                [_vModelRadio, _unref(format)]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "format_xlsx" }, "XLSX", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(BaseButton, {
          title: _ctx.$t('auth.phone.continue'),
          size: "large",
          color: "primary",
          disabled: !_unref(isValid),
          onClick: _unref(handleSubmit)
        }, null, 8, ["title", "disabled", "onClick"])
      ])
    ])
  ]))
}
}

})